// extracted by mini-css-extract-plugin
export default {"menuCenter":"MenuCenter_menuCenter__iNXEf","menuCenter__list":"MenuCenter_menuCenter__list__ObyoB","menuCenterItem":"MenuCenter_menuCenterItem__nCtek"};